import React, { Component } from 'react';
import './SegmentAttractiveness.css';
import _ from 'lodash';
import Criteria from './Criteria/Criteria';
import AttractivenessWeight from './AttractivenessWeight/AttractivenessWeight';
import RateAttractivenessWeight from './RateAttractiveness/RateAttractivenessWeight';
import Success from './Succes/Success';
class SegmentAttractiveness extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepState: 1,
            tabStep: 0
        }
    }

    stateNext = (step) => {
        this.setState({  stepState: this.state.stepState + 1 })
    }

    stateBack = (step) => {
        this.setState({  stepState: this.state.stepState - 1 })
    }
    onTabChange=(number)=>{
        this.setState({tabStep: number})
    }

    componentWillMount() {
        localStorage.setItem("openedTool", this.props.projectId);
    }

    render() {

        return (
            <div className='projects-content challenge-statement-content'>
                <div>
                    {this.state.stepState === 1 &&
                        <Criteria
                            getCustomerGroup={this.props.getCustomerGroup}
                            projectId={this.props.projectId}
                            getCustomerGroupsFetching={this.props.getCustomerGroupsFetching}
                            getCustomerGroupsData={this.props.getCustomerGroupsData}
                            getAttractivness={this.props.getAttractivness}
                            attractivnessFetching={this.props.attractivnessFetching}
                            attractivnessData={this.props.attractivnessData}
                            createCriteriaTab={this.props.createCriteriaTab}
                            editCriteriaTab={this.props.editCriteriaTab}
                            stateNext={this.stateNext}
                            craetCriteriaFetching={this.props.craetCriteriaFetching}
                            craetCriteriaData={this.props.craetCriteriaData}
                            stepState={this.state.stepState}
                            tabStep={this.state.tabStep}
                            onTabChange={this.onTabChange}
                        />
                    }
                    {this.state.stepState === 2 &&
                        <AttractivenessWeight
                            getCustomerGroup={this.props.getCustomerGroup}
                            projectId={this.props.projectId}
                            getCustomerGroupsFetching={this.props.getCustomerGroupsFetching}
                            getCustomerGroupsData={this.props.getCustomerGroupsData}
                            getAttractivness={this.props.getAttractivness}
                            attractivnessFetching={this.props.attractivnessFetching}
                            attractivnessData={this.props.attractivnessData}
                            createCriteriaTab={this.props.createCriteriaTab}
                            editCriteriaTab={this.props.editCriteriaTab}
                            stateNext={this.stateNext}
                            getSegmentsName={this.props.getSegmentsName}
                            getSegmentFetching={this.props.getSegmentFetching} 
                            getSegmentData={this.props.getSegmentData}
                            stateBack={this.stateBack}
                            stepState={this.state.stepState}
                            craetCriteriaFetching={this.props.craetCriteriaFetching}
                            craetCriteriaData={this.props.craetCriteriaData}
                            tabStep={this.state.tabStep}
                            onTabChange={this.onTabChange}
                        />
                    }

                    { this.state.stepState === 3 &&
                        <RateAttractivenessWeight
                            getCustomerGroup={this.props.getCustomerGroup}
                            projectId={this.props.projectId}
                            getCustomerGroupsFetching={this.props.getCustomerGroupsFetching}
                            getCustomerGroupsData={this.props.getCustomerGroupsData}
                            getAttractivness={this.props.getAttractivness}
                            attractivnessFetching={this.props.attractivnessFetching}
                            attractivnessData={this.props.attractivnessData}
                            createCriteriaTab={this.props.createCriteriaTab}
                            editCriteriaTab={this.props.editCriteriaTab}
                            stateNext={this.stateNext}
                            getSegmentsName={this.props.getSegmentsName}
                            getSegmentFetching={this.props.getSegmentFetching} 
                            getSegmentData={this.props.getSegmentData}
                            stateBack={this.stateBack}
                            stepState={this.state.stepState}
                            craetCriteriaFetching={this.props.craetCriteriaFetching}
                            craetCriteriaData={this.props.craetCriteriaData}
                            tabStep={this.state.tabStep}
                            onTabChange={this.onTabChange}
                        />
                    }

                    { this.state.stepState === 4 && 
                        <Success
                            getCustomerGroup={this.props.getCustomerGroup}
                            projectId={this.props.projectId}
                            getCustomerGroupsFetching={this.props.getCustomerGroupsFetching}
                            getCustomerGroupsData={this.props.getCustomerGroupsData}
                            getAttractivness={this.props.getAttractivness}
                            attractivnessFetching={this.props.attractivnessFetching}
                            attractivnessData={this.props.attractivnessData}
                            createCriteriaTab={this.props.createCriteriaTab}
                            editCriteriaTab={this.props.editCriteriaTab}
                            stateNext={this.stateNext}
                            getSegmentsName={this.props.getSegmentsName}
                            getSegmentFetching={this.props.getSegmentFetching} 
                            getSegmentData={this.props.getSegmentData}
                            stateBack={this.stateBack}
                            stepState={this.state.stepState}
                            craetCriteriaFetching={this.props.craetCriteriaFetching}
                            craetCriteriaData={this.props.craetCriteriaData}
                            tabStep={this.state.tabStep}
                            onTabChange={this.onTabChange}
                        />
                    }

                </div>
            </div>
        )
    }
}
export default (SegmentAttractiveness);


// WEBPACK FOOTER //
// ./src/components/SegmentAttractiveness/SegmentAttractiveness.jsx